import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { scrollToPricing } from '../utils/scrollTo';
import { trackMetaPixel } from '../utils/metaPixel';
export const Countdown = () => {
  // Start at 23:59:37 in seconds
  const [timeLeft, setTimeLeft] = useState(23 * 3600 + 59 * 60 + 37);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section className="bg-red-700 text-white py-8 px-4 text-center border-y-4 border-red-800" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        <h2 className="text-xl md:text-2xl font-bold mb-4 uppercase tracking-wide" data-id="element-95">
          ⏰ PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO
        </h2>
        <div className="flex justify-center gap-4 text-3xl md:text-5xl font-black tabular-nums mb-4" data-id="element-96">
          <div className="flex flex-col items-center" data-id="element-97">
            <span className="bg-red-800 px-4 py-2 rounded-lg shadow-inner" data-id="element-98">
              {hours.toString().padStart(2, '0')}
            </span>
            <span className="text-xs font-medium mt-2 text-red-200 uppercase" data-id="element-99">
              HS
            </span>
          </div>
          <span className="py-2" data-id="element-100">:</span>
          <div className="flex flex-col items-center" data-id="element-101">
            <span className="bg-red-800 px-4 py-2 rounded-lg shadow-inner" data-id="element-102">
              {minutes.toString().padStart(2, '0')}
            </span>
            <span className="text-xs font-medium mt-2 text-red-200 uppercase" data-id="element-103">
              MIN
            </span>
          </div>
          <span className="py-2" data-id="element-104">:</span>
          <div className="flex flex-col items-center" data-id="element-105">
            <span className="bg-red-800 px-4 py-2 rounded-lg shadow-inner" data-id="element-106">
              {seconds.toString().padStart(2, '0')}
            </span>
            <span className="text-xs font-medium mt-2 text-red-200 uppercase" data-id="element-107">
              SEG
            </span>
          </div>
        </div>
        <p className="text-red-100 font-medium flex items-center justify-center gap-2" data-id="element-108">
          <span className="w-2 h-2 rounded-full bg-red-300 animate-pulse" data-id="element-109"></span>
          🔴 El precio sube cuando termina el contador
        </p>
      </div>
    </section>;
};
const CHECKOUT_LINKS = {
  profesional: 'https://recursosprofesionales.com.ar/checkouts/cn/hWNDSWyvr7BBRHj8R4lMEZBy/es-ar?_r=AQABMR9nF58LExw75afEYQ7lX213bGAt-mf0Sr8f2_qaIgY',
  elite: 'https://recursosprofesionales.com.ar/checkouts/cn/hWNDSWzH0SE2zEH2N0SnI8gs/es-ar?_r=AQABX0pUheFdwpAvKKTVV9SS-sEzEPKrG-14MUPs-C_vPLU'
};
export const Pricing = () => {
  const [selected, setSelected] = useState<'profesional' | 'elite'>('elite');
  return <section id="precios" className="py-20 bg-slate-100 px-4 sm:px-6 lg:px-8 scroll-mt-10" data-id="element-110">
      <div className="max-w-xl mx-auto" data-id="element-111">
        <div className="bg-white rounded-3xl p-6 sm:p-10 shadow-xl border border-slate-200" data-id="element-112">
          <div className="text-center mb-8" data-id="element-113">
            <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-3" data-id="element-114">
              Elegí tu Pack:
            </h2>
            <p className="text-base text-slate-500 font-medium" data-id="element-115">
              Ambas opciones incluyen los 6 Bonus estratégicos
            </p>
          </div>

          <div className="space-y-4 mb-8" data-id="element-116">
            {/* Pack Profesional */}
            <button type="button" onClick={() => setSelected('profesional')} aria-pressed={selected === 'profesional'} className={`w-full text-left rounded-2xl p-5 border-2 transition-all flex items-start gap-4 ${selected === 'profesional' ? 'border-teal-600 bg-teal-50' : 'border-slate-200 bg-white hover:border-slate-300'}`} data-id="element-117">
              <span className={`mt-1 flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'profesional' ? 'border-teal-600' : 'border-slate-300'}`} data-id="element-118">
                {selected === 'profesional' && <span className="w-3 h-3 rounded-full bg-teal-600" data-id="element-119" />}
              </span>
              <div className="flex-grow min-w-0" data-id="element-120">
                <h3 className="text-base sm:text-lg font-bold text-slate-900 flex items-center gap-2" data-id="element-121">
                  📘 PACK PROFESIONAL
                </h3>
                <p className="text-sm text-slate-500 mt-1" data-id="element-122">
                  12 Tomos + 6 Bonus
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-123">
                <p className="text-slate-400 line-through text-xs sm:text-sm font-medium" data-id="element-124">
                  $39.990
                </p>
                <p className="text-xl sm:text-2xl font-black text-slate-900 whitespace-nowrap" data-id="element-125">
                  $22.990
                </p>
              </div>
            </button>

            {/* Megapack Élite */}
            <button type="button" onClick={() => setSelected('elite')} aria-pressed={selected === 'elite'} className={`w-full text-left rounded-2xl p-5 border-2 transition-all flex items-start gap-4 ${selected === 'elite' ? 'border-teal-600 bg-teal-50' : 'border-slate-200 bg-white hover:border-slate-300'}`} data-id="element-126">
              <span className={`mt-1 flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'elite' ? 'border-teal-600' : 'border-slate-300'}`} data-id="element-127">
                {selected === 'elite' && <span className="w-3 h-3 rounded-full bg-teal-600" data-id="element-128" />}
              </span>
              <div className="flex-grow min-w-0" data-id="element-129">
                <h3 className="text-base sm:text-lg font-black text-slate-900 flex items-center gap-2" data-id="element-130">
                  🏆 MEGAPACK ÉLITE
                </h3>
                <div className="flex flex-wrap gap-2 my-2" data-id="element-131">
                  <span className="bg-yellow-400 text-yellow-900 font-black px-3 py-0.5 rounded-full text-xs uppercase tracking-wide" data-id="element-132">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="bg-red-100 text-red-700 font-bold px-3 py-0.5 rounded-full text-xs" data-id="element-133">
                    AHORRÁS $7.000
                  </span>
                </div>
                <p className="text-sm text-slate-500" data-id="element-134">
                  12 Tomos + 6 Bonus + 2 EBOOKS ÉLITE
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-135">
                <p className="text-slate-400 line-through text-xs sm:text-sm font-medium" data-id="element-136">
                  $49.990
                </p>
                <p className="text-xl sm:text-2xl font-black text-teal-700 whitespace-nowrap" data-id="element-137">
                  $29.990
                </p>
              </div>
            </button>
          </div>

          <a href={CHECKOUT_LINKS[selected]} target="_blank" rel="noopener noreferrer" onClick={() => trackMetaPixel('InitiateCheckout', {
          content_name: selected === 'elite' ? 'Megapack Élite' : 'Pack Profesional',
          value: selected === 'elite' ? 29990 : 22990,
          currency: 'ARS'
        })} className="w-full bg-teal-600 hover:bg-teal-700 text-white text-base sm:text-lg font-black py-5 px-6 rounded-xl shadow-lg hover:shadow-xl transform transition hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-138">
            {selected === 'elite' ? 'SÍ, QUIERO EL MEGAPACK ÉLITE →' : 'SÍ, QUIERO EL PACK PROFESIONAL →'}
          </a>

          <p className="text-center text-sm italic text-slate-500 mt-6" data-id="element-139">
            La opción más elegida por kinesiólogos independientes argentinos
          </p>
        </div>

        {/* Trust row */}
        <div className="mt-8 grid grid-cols-2 gap-4 max-w-md mx-auto text-sm text-slate-500 font-medium" data-id="element-140">
          <span className="flex items-center gap-2" data-id="element-141">
            <Lock className="w-4 h-4 text-slate-400" data-id="element-142" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-143">
            <Zap className="w-4 h-4 text-amber-500" data-id="element-144" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-2" data-id="element-145">
            <ShieldCheck className="w-4 h-4 text-teal-600" data-id="element-146" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-147">
            <CreditCard className="w-4 h-4 text-slate-400" data-id="element-148" /> Tarjeta ·
            Transferencia
          </span>
        </div>
        <p className="text-center text-xs text-slate-400 mt-4" data-id="element-149">
          Tarjeta · Transferencia · Mercado Pago
        </p>
      </div>
    </section>;
};
// Lightweight Zap icon
const Zap = ({
  className
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-150">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" data-id="element-151" />
  </svg>;